import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  caption: {
    position: 'absolute',
    top: 25,
    right: 20,
  },
  control: {
    position: 'relative',
    width: '100%',
  },
}));
